import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter as Router } from "react-router-dom";
import 'normalize.css/normalize.css';
import './styles/index.css';
import Auth from './auth';

// MSAL imports
import { EventType } from "@azure/msal-browser";
import { msalInstance } from "./msalInstance";

// MSAL v3+ erfordert eine explizite Initialisierung, BEVOR andere APIs
// (getAllAccounts, setActiveAccount, addEventCallback, ...) verwendet werden
// dürfen. Ohne initialize() würde v5 mit
// "BrowserAuthError: uninitialized_public_client_application" abbrechen.
msalInstance.initialize().then(() => {
  // Default to using the first account if no account is active on page load
  if (!msalInstance.getActiveAccount() && msalInstance.getAllAccounts().length > 0) {
    // Account selection logic is app dependent. Adjust as needed for different use cases.
    msalInstance.setActiveAccount(msalInstance.getAllAccounts()[0]);
  }

  // Hinweis: Das frühere `msalInstance.enableAccountStorageEvents()` wurde in
  // MSAL Browser v3+ ersatzlos entfernt. Es war ein Opt-in für die Cross-Tab-
  // Events ACCOUNT_ADDED / ACCOUNT_REMOVED, die wir hier ohnehin nicht
  // auswerten. `LOGIN_SUCCESS` wird auch ohne diesen Aufruf gefeuert.

  msalInstance.addEventCallback((event) => {
    // LOGIN_SUCCESS feuert bei interaktivem Login, ACQUIRE_TOKEN_SUCCESS u.a.
    // auch nach Redirect-Return / Silent-Token-Acquisition. Beide Pfade liefern
    // ein `account` im Payload — wir nehmen beides, damit `getActiveAccount()`
    // möglichst früh besetzt ist (v2 setzte den Active Account in mehr Fällen
    // implizit, v5 verlangt das explizit).
    if (
      (event.eventType === EventType.LOGIN_SUCCESS ||
        event.eventType === EventType.ACQUIRE_TOKEN_SUCCESS) &&
      event.payload?.account
    ) {
      msalInstance.setActiveAccount(event.payload.account);
    }
  });

  const root = ReactDOM.createRoot(document.getElementById('root'));
  root.render(
      <Router>
          <Auth pca={msalInstance}/>
      </Router>
  );
});
